import { cancelAllRequests, createApiEndpoint, ApiMethod } from './baseApi';
import {
    ApiResponse,
    PagedResult
} from 'types';
import { PagedCriteriaBase } from '../types/api.interfaces';

interface AppointmentSearchResult {
    bookedBy: string;
    serviceName: string;
    speciality: string;
    slotDate: Date;
    appointmentTypeName: string;
    systemName: string;
    siteName: string;
    patientName: string;
    idBookedAppointment: number;
    birthDate?: Date | null;
    attendance: string;
    patientRefernceId?: string | null;
    slotEndDate: Date;
    providerResponse: string | null;
    reasonForVisit: string | null;
    appointmentReferenceId: string;
    payorType: string | null;
    decisionSupportSessionId: string | null
}

interface AppointmentsSearchCriteria extends PagedCriteriaBase {
    practiceSiteId: number,
    serviceId: number,
    appointmentStartTime: string,
	appointmentEndTime: string,
}

enum ApiRoute {
	Search = 'internal/practicesite/appointments',
}

const search = async (criteria: AppointmentsSearchCriteria, setState: (result: ApiResponse<PagedResult<AppointmentSearchResult>>) => void): Promise<void> => {
    const api = createApiEndpoint<AppointmentsSearchCriteria>(ApiRoute.Search, ApiMethod.POST);
	await api(setState, criteria);
};

const searchAppointmentService = {
	search,
};

export default searchAppointmentService;